import React, {Component} from 'react';
import moment from 'moment';
import Modal from '../../components/Modal';
// import {unmarkAsDud} from '../../actions/ClientActions';
import api from '../../api';
import SearchInput from '../../components/SearchInput';
import ClientPreview from '../../components/clients/ClientPreview';

export default class MarkReferrerModal extends Component {

    constructor(props){
        super(props);
        this.state = {
            clients : [],
            resultText : null,
            errorText : null
        }
    }

    handleSave() {
        // dispatch(unmarkAsDud(this.props.client.id));
    }

    handleOnPrimaryClientSearch(searchText) {
        api.post('/clients/search', {showFullResult: true, limit: 5, page: 1, searchText: searchText}).then(res => {
            this.setState({clients: res.value.clients});
        });
    }

    async handleChooseClient(client){     

        this.setState({
            resultText : "Loading...",
            errorText : null
        })

        try {
            var result = await api.post('/client_mark_as_referred_by', {
                newClientId : this.props.client.id,
                oldReferringClientId : client.id
            });
            this.setState({
                resultText : result.value.message,
                errorText : null
            });
        }                
        catch(e){
            console.error(e);
            var message = "Could not mark as referred";
            if (e instanceof Error){
                message = e.message;
            } else if (e.error){
                message = e.error;
            }

            this.setState({
                resultText : null,
                errorText : message
            });         
        }
    }

    render() {        

        return (
            <Modal className="modal-default" title={"Mark the referring company for " + this.props.client.name}>
                <p>Mark <strong>{this.props.client.name}</strong> as being referred by</p>

                {this.state.resultText && 
                    <div className="alert alert-success">{this.state.resultText}</div>
                }
                {this.state.errorText && 
                    <div className="alert alert-danger">{this.state.errorText}</div>
                }

                <SearchInput placeholder="Search for Master Client to merge into"                                 
                                 onSearch={this.handleOnPrimaryClientSearch.bind(this)} />
                <div style={{marginTop: '20px'}}>
                        {this.state.clients.length === 0 && 
                            <div style={{opacity: 0.8}}>No clients</div>
                        }
                        {this.state.clients.map(c => {
                            if (moment(c.signedUpAt).isAfter(moment(this.props.client.signedUpAt)) || ! c.isPaying) {
                                return (
                                    <div className="row" key={c.id} style={{borderTop : '1px solid #ccc', padding : '9px'}}>
                                        <a href={"/clients/" + c.id}>{c.name}</a> is not elible to be referred by this customer. <br/>
                                        { !c.isPaying && <span className="label label-danger">(They are not a paying customer)</span> }
                                        <br/>
                                        { moment(c.signedUpAt).isAfter(moment(this.props.client.signedUpAt)) && <span className="label label-danger">(They were created after {this.props.client.name})</span> }
                                        
                                    </div>
                                )
                            }
                            return (
                                <div className="row" key={c.id} style={{borderTop : '1px solid #ccc', paddingTop : '9px'}}>
                                    <div className="col-md-8">                                        
                                        <ClientPreview onPageClientId={c} client={c} staff={[]} />                                        
                                    </div>
                                    <div className="col-md-4">
                                        <button className={'btn btn-success'} onClick={this.handleChooseClient.bind(this, c)}>
                                            <i className="fa fa-check"></i> Mark as Referrer
                                        </button>
                                    </div>                                    
                                </div>
                            );
                        })}
                    </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/MarkReferrerModal.js